import React from 'react';
import './Home.css';

const Home: React.FC = () => {
    return (
        <div className="home">
            <div className="home-center">
                <p className="coming-soon">coming soon</p>
            </div>
        </div>
    );
}; export default Home; // By John Michael
